module.exports = __webpack_public_path__ + "media/images/partners/nezavisimaya_ocenka2025-48127924b5574e16e51873070dee9b2b.svg";